import React from "react"

interface PersonaAvatarProps {
  persona: string
  size?: "sm" | "md" | "lg"
  role?: "user" | "assistant"
}

export const PersonaAvatar: React.FC<PersonaAvatarProps> = ({ persona, size = "md", role = "assistant" }) => {
  const getPersonaEmoji = (persona: string) => {
    switch (persona) {
      case "todoist":
        return "📋"
      case "planning":
        return "🧠"
      case "debug":
        return "🔧"
      case "random":
        return "🎲"
      case "aliya":
        return "👶"
      case "ayesha":
        return "❤️"
      case "vidmax":
        return "🎥"
      case "billionaire_coach":
        return "💰"
      case "longevity_fitness":
        return "💪"
      case "task_creator":
        return "✅"
      case "personal_brand":
        return "🌟"
      case "nutrition_accountability":
        return "🥗"
      default:
        return "🤖"
    }
  }

  const getPersonaName = (persona: string) => {
    switch (persona) {
      case "todoist":
        return "Task Assistant"
      case "planning":
        return "Planning Assistant"
      case "debug":
        return "Debug Assistant"
      case "random":
        return "General Assistant"
      case "aliya":
        return "Aliya"
      case "ayesha":
        return "Family Strategist"
      case "vidmax":
        return "Vidmax Strategy"
      case "billionaire_coach":
        return "Founder Coach"
      case "longevity_fitness":
        return "Health Advisor"
      case "task_creator":
        return "Task Creator"
      case "personal_brand":
        return "Brand Strategist"
      case "nutrition_accountability":
        return "Fitness Coach"
      default:
        return "AI Assistant"
    }
  }

  const getPersonaColor = (persona: string) => {
    switch (persona) {
      case "todoist":
        return "#e74c3c"
      case "planning":
        return "#3498db"
      case "debug":
        return "#f39c12"
      case "random":
        return "#9b59b6"
      case "aliya":
        return "#ffb6c1"
      case "ayesha":
        return "#ff69b4"
      case "vidmax":
        return "#1abc9c"
      case "billionaire_coach":
        return "#f1c40f"
      case "longevity_fitness":
        return "#27ae60"
      case "task_creator":
        return "#2ecc71"
      case "personal_brand":
        return "#e67e22"
      case "nutrition_accountability":
        return "#2ecc71"
      default:
        return "#6366f1"
    }
  }

  const sizeClasses = {
    sm: "w-8 h-8 text-sm",
    md: "w-10 h-10 text-base",
    lg: "w-12 h-12 text-lg",
  }

  if (role === "user") {
    return (
      <div
        className={`${sizeClasses[size]} rounded-full bg-primary flex items-center justify-center text-white font-bold`}
      >
        👤
      </div>
    )
  }

  return (
    <div
      className={`${sizeClasses[size]} rounded-full flex items-center justify-center font-bold text-white relative group cursor-pointer`}
      style={{ backgroundColor: getPersonaColor(persona) }}
      title={`${getPersonaName(persona)} (${persona})`}
    >
      <span className="text-white">{getPersonaEmoji(persona)}</span>

      {/* Tooltip */}
      <div className="absolute bottom-full mb-2 left-1/2 transform -translate-x-1/2 px-2 py-1 bg-gray-900 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap z-10">
        {getPersonaName(persona)}
      </div>
    </div>
  )
}
